var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { DatevSettingsActorType, DatevSettingsFoldout, } from '../types/datev-settings-history.js';
/**
 * Read shape of the actor on a history row. `label` is a display-ready
 * string (`steuerberater-token-<id>` for a share-link write, the user id for
 * a logged-in write) so the frontend never branches on `type` to render it.
 */
export class DatevSettingsChangeActorDto {
    type;
    /** Logged-in user id, or the ADMIN who issued the Steuerberater token. */
    userId;
    /** Steuerberater token id; `null` for a logged-in write. */
    tokenId;
    label;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], DatevSettingsChangeActorDto.prototype, "type", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], DatevSettingsChangeActorDto.prototype, "userId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], DatevSettingsChangeActorDto.prototype, "tokenId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], DatevSettingsChangeActorDto.prototype, "label", void 0);
/**
 * One row of the DATEV-settings Änderungshistorie (PRD #1319 / RS-002).
 * Insertion-only, newest-first when listed. `changedFields` carries only the
 * fields that actually changed; a no-op save produces no row at all.
 */
export class DatevSettingsChangeResponseDto {
    id;
    officeLocationId;
    changedAt;
    actor;
    foldout;
    changedFields;
    /** Justification captured when a frozen setting is changed (RS-003). */
    reason;
    /** Number of carry-over vouchers seeded by a mode switch (RS-004). */
    carryOverCount;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], DatevSettingsChangeResponseDto.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], DatevSettingsChangeResponseDto.prototype, "officeLocationId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], DatevSettingsChangeResponseDto.prototype, "changedAt", void 0);
__decorate([
    Expose(),
    Type(() => DatevSettingsChangeActorDto),
    __metadata("design:type", DatevSettingsChangeActorDto)
], DatevSettingsChangeResponseDto.prototype, "actor", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], DatevSettingsChangeResponseDto.prototype, "foldout", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], DatevSettingsChangeResponseDto.prototype, "changedFields", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], DatevSettingsChangeResponseDto.prototype, "reason", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], DatevSettingsChangeResponseDto.prototype, "carryOverCount", void 0);
//# sourceMappingURL=datev-settings-change.response.dto.js.map